import { render } from "./agentSerial.vue?vue&type=template&id=ac1690f8&scoped=true"
import script from "./agentSerial.vue?vue&type=script&lang=js"
export * from "./agentSerial.vue?vue&type=script&lang=js"

import "./agentSerial.vue?vue&type=style&index=0&id=ac1690f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac1690f8"

export default script